<template>
  <!-- <base-section id="blog-page"> -->
  <!-- <v-container> -->
  <v-col cols="12" sm="12" md="12" lg="12">
    <v-row v-if="images && images.length > 0">
      <carousel-image :slides="images" />
    </v-row>
    <v-col
      v-if="content && content.sections && content.sections.length > 0"
      cols="12"
      sm="12"
      md="12"
      lg="12"
    >
      <v-row v-for="(section, index) in content.sections" :key="index">
        <top-image
          :section="section"
          v-if="
            section.contentType == 'TOP_IMAGE' ||
            section.contentType == 'FULL_CONTENT'
          "
        />
        <half-image
          :section="section"
          v-if="section.contentType == 'HALF_IMAGE'"
        />
        <blocks-1
          :section="section"
          col="4"
          v-if="section.contentType == '3_BLOCKs_TYPE_1'"
        />
        <blocks-1
          :section="section"
          col="3"
          v-if="section.contentType == '4_BLOCKs_TYPE_1'"
        />
        <blocks-2
          :section="section"
          v-if="section.contentType == '3_BLOCKs_TYPE_2'"
        />
      </v-row>
    </v-col>
  </v-col>
  <!-- </v-container> -->
  <!-- </base-section> -->
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import CarouselImage from "@/views/home/page/CarouselImage.vue";
import TopImage from "@/views/home/page/TopImage.vue";
import HalfImage from "@/views/home/page/HalfImage.vue";
import Blocks1 from "@/views/home/page/Blocks1.vue";
import Blocks2 from "@/views/home/page/Blocks2.vue";

@Component({
  name: "Page",
  components: { CarouselImage, TopImage, HalfImage, Blocks1, Blocks2 },
  props: {
    content: {
      default: null,
    },
  },
})
export default class Page extends Vue {
  screen = null;
  images = [];
  async mounted() {
    if (this.content) {
      if (this.content.homeBlock && this.content.homeBlock.images) {
        for (let i = 0; i < this.content.homeBlock.images.length; i++) {
          if (
            this.content.homeBlock.images[i] &&
            this.content.homeBlock.images[i].url
          ) {
            this.images.push(this.content.homeBlock.images[i].url);
          }
        }
      }
    }
  }
}
</script>
